export const EMAIL_CHANGED = 'EMAIL_CHANGED' as const;
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED' as const;
export const LOGIN_USER = 'LOGIN_USER' as const;
export const LOGIN_USER_PENDING = 'LOGIN_USER_PENDING' as const;
export const LOGIN_USER_FULFILLED = 'LOGIN_USER_FULFILLED' as const;
export const LOGIN_USER_REJECTED = 'LOGIN_USER_REJECTED' as const;
export const LOGOUT_USER = 'LOGOUT_USER' as const;
export const LOGOUT_USER_PENDING = 'LOGOUT_USER_PENDING' as const;
export const LOGOUT_USER_FULFILLED = 'LOGOUT_USER_FULFILLED' as const;
export const LOGOUT_USER_REJECTED = 'LOGOUT_USER_REJECTED' as const;
export const SIGNUP_USER = 'SIGNUP_USER' as const;
export const SIGNUP_USER_PENDING = 'SIGNUP_USER_PENDING' as const;
export const SIGNUP_USER_FULFILLED = 'SIGNUP_USER_FULFILLED' as const;
export const SIGNUP_USER_REJECTED = 'SIGNUP_USER_REJECTED' as const;
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD' as const;
export const FORGOT_PASSWORD_PENDING = 'FORGOT_PASSWORD_PENDING' as const;
export const FORGOT_PASSWORD_FULFILLED = 'FORGOT_PASSWORD_FULFILLED' as const;
export const FORGOT_PASSWORD_REJECTED = 'FORGOT_PASSWORD_REJECTED' as const;
export const GET_ME = 'GET_ME' as const;
export const GET_ME_PENDING = 'GET_ME_PENDING' as const;
export const GET_ME_FULFILLED = 'GET_ME_FULFILLED' as const;
export const GET_ME_REJECTED = 'GET_ME_REJECTED' as const;
